import { render, staticRenderFns } from "./DealerPlateTransaction.vue?vue&type=template&id=6ac2555a&scoped=true&"
import script from "./DealerPlateTransaction.vue?vue&type=script&lang=js&"
export * from "./DealerPlateTransaction.vue?vue&type=script&lang=js&"
import style0 from "./DealerPlateTransaction.vue?vue&type=style&index=0&id=6ac2555a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2555a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
